/* eslint-disable */
import { cloneDeep } from 'lodash'

const ZOOM_MAX = 100
const ZOOM_MIN = 0.0005
const channel = {
  mode: 'double',
  offset: {
    x: 0,
    y: 0
  },
  amp: 1, // 피크 전압
  freq: 0, // 주파수 (Hz)
  factor: { // scaling
    x: 1,
    y: 1
  },
  xdata: [],
  ydata: [],
  unit: 10,
  type: ''
}
const sine = function (x, freq, amp, offset) {
  return amp * Math.sin(2 * Math.PI * freq * (x - offset.x)) + offset.y
}
const fourierSeries = function (x, T, amp, offset) {
  let val = 0
  for (let i = 1; i < 500; i += 2) {
    val += -amp * Math.sin(i * (x - offset.x) * (6 / T)) / i
  }
  val *= 4 / Math.PI
  return val + offset.y
}
const triangle = function (x, T, amp, offset) {
  if (T === 0) return 0
  const a = (4 * amp) / T
  const t = 1 / T * Math.abs((x + 0.25 - offset.x) * T) % T
  if (t <= T / 2) {
    return a * (t - 1 / 4 * T) + offset.y
  } else {
    return -a * (t - 3 / 4 * T) + offset.y
  }
}
const getFrequencyFactor = function (freq) {
  const a = Math.floor(freq / 10)
  return a === 0 ? 1 : a
}
const setSVGElementSize = (dom, width, height) => {
  const svg = document.getElementById(dom).getElementsByTagName('svg')[0]
  console.log(svg.width, svg.height)
  svg.setAttribute('width', width+'px')
  svg.setAttribute('height', height+'px')
}

export const graph = {
  data () {
    return {
      JXG: window.JXG,
      board: null,
      graphid: 'root-graph',
      mode: 'double', // 'single'(only one graph), 'double'(two graph), 'animate'
      mainChannel: null,
      mainGraphElement: null,
      channels: {
        ch1: cloneDeep(channel),
        ch2: cloneDeep(channel)
      },
      attr: { // JSXgraph attributes
        axis: true,
        grid: true,
        showNavigation: false,
        colors: ['yellow', 'red'], // [ch1 color, ch2 color], color: red, yellow(default), green, blue
        animated: {
          status: false,
          start: 0
        },
        factor: {
          x: 1,
          y: 1
        }
      },
      inter: null,
      values: null
    }
  },
  methods: {
    getMainChannel (attr = 'freq') {
      const { ch1, ch2 } = this.channels
      if (ch1[attr] && ch2[attr]) return ch1[attr] > ch2[attr] ? ch1 : ch2
      else if (ch1[attr]) return ch1
      else if (ch2[attr]) return ch2
      else return ch1
    },
    getChannelObject (ch) {
      return ch === 'ch1' ? this.channels.ch1 : this.channels.ch2
    },
    getGraphColorByChannel (ch) {
      return ch === 'ch1' ? this.attr.colors[0] : this.attr.colors[1]
    },
    setGraphXYData (ch1 = { xdata: [], ydata: [] }, ch2 = { xdata: [], ydata: [] }) {
      this.channels.ch1.xdata = ch1.xdata
      this.channels.ch1.ydata = ch1.ydata
      this.channels.ch2.xdata = ch2.xdata
      this.channels.ch2.ydata = ch2.ydata
    },
    setFunctionGraphData (ch1 = { freq: 0, type: '' }, ch2 = { freq: 0, type: '' }) {
      this.channels.ch1.freq = ch1.freq
      this.channels.ch1.type = ch1.type
      this.channels.ch2.freq = ch2.freq
      this.channels.ch2.type = ch2.type
      if (!this.values) this.values = [ch1, ch2]
    },
    initBoard (mode = 'double', domId = 'root-graph', boundingBox = [-1, 1, 1, -1]) {
      if (this.board) {
        window.JXG.JSXGraph.freeBoard(this.board)
        this.board = null
      }
      this.mode = mode
      this.graphid = domId
      this.mainChannel = this.getMainChannel()
      const x = boundingBox[2]
      const y = boundingBox[1]
      const fc = 1 / getFrequencyFactor(this.mainChannel.freq)
      const factor = this.mainChannel.factor
      boundingBox = [-x * factor.x * fc / 2, y * factor.y, x * factor.x * fc / 2, -y * factor.y]
      const { axis, grid, showNavigation } = this.attr
      this.board = window.JXG.JSXGraph.initBoard(domId,
        {
          axis,
          grid,
          showNavigation,
          showCopyright: false,
          boundingBox,
          resize: {enabled: true, throttle: 200}
        })
      // this.board.resizeContainer(250, 130, true, false)
      // console.log(this.$store.state.sim.zoomlevel)
      setTimeout(() => {
        setSVGElementSize(domId, 250, 130)
      }, 500);
    },
    initAnimateBoard (mode, domId = 'root-graph', ch1, ch2, xticks = false, boundingBox = [0, 1, 10, -1] ) {
      if (this.board) this.freeBoard()
      this.mode = mode
      // const maxy = Math.max(Math.max(...ch1.ydata), Math.max(...ch2.ydata))
      // let boundingBox = null;
      if (mode === 'static') {
        // boundingBox = [-0.1, maxy * 1.5, 1.1, -maxy * 1.5]
        // boundingBox = [-0.1, 5, 1.02, -5]
        this.setGraphXYData(ch1, ch2)
      } else if (mode === 'period') {
        // boundingBox = [-0.1 ,maxy * 1.5, ch1.range, -maxy * 1.5]
      }
      // boundingBox = [-0.1, 5, 1.02, -5]
      // boundingBox = [0, 1, 10, -1]
      // console.log('initAnimateBoard', boundingBox)
      const { axis, grid, showNavigation } = this.attr
      this.board = window.JXG.JSXGraph.initBoard(domId,
        {
          axis,
          defaultAxes: {
            x: { ticks: { visible : xticks } }
          },
          grid,
          showNavigation,
          showCopyright: false,
          boundingBox
        })
      /*
        this.board.create('curve', [this.channels.ch1.xdata, this.channels.ch1.ydata],
        { strokeWidth: 2, strokeColor: 'yellow' })
      this.board.create('curve', [this.channels.ch2.xdata, this.channels.ch2.ydata], { strokeWidth: 2, strokeColor: 'red' })
      */
      setTimeout(() => {
        setSVGElementSize(domId, 250, 130)
      }, 500);
    },
    freeBoard () {
      window.JXG.JSXGraph.freeBoard(this.board)
      this.board = null
      if (this.inter) {
        clearInterval(this.inter)
        this.inter = null
      }
      this.channels.ch1 = cloneDeep(channel)
      this.channels.ch2 = cloneDeep(channel)
    },
    setGraphAttribute (axis = true, grid = true, showNavigation = false) {
      this.attr.axis = axis
      this.attr.grid = grid
      this.attr.showNavigation = showNavigation
    },
    setGraphFactor (ch = 'both', factor) {
      if (ch === 'ch1') {
        this.channels.ch1.factor.x = factor.x
        this.channels.ch1.factor.y = factor.y
      } else if (ch === 'ch2') {
        this.channels.ch2.factor.x = factor.x
        this.channels.ch2.factor.y = factor.y
      } else {
        this.attr.factor.x = factor.x
        this.attr.factor.y = factor.y
      }
    },
    drawGraphByType (type, ch) {
      if (!this.board) return
      switch (type) {
        case 'sine':
          this.drawSineWave(ch)
          break
        case 'square':
          this.drawSquareWave(ch)
          break
        case 'tri':
          this.drawTriWave(ch)
          break
      }
      this.board.update()
    },
    drawSineWave (ch, freq = 0) {
      const _channel = this.getChannelObject(ch)
      const boundingBox = this.board.getBoundingBox()
      const color = this.getGraphColorByChannel(ch)
      freq = freq === 0 ? _channel.freq : freq
      this.board.create('functiongraph', [
        (x) => {
          return sine(x, freq, _channel.amp, _channel.offset)
        }, boundingBox[0], boundingBox[2]],
      { strokeColor: color, strokeWidth: 1 }
      )
    },
    drawSquareWave (ch, freq = 0) {
      const _channel = this.getChannelObject(ch)
      const boundingBox = this.board.getBoundingBox()
      const color = this.getGraphColorByChannel(ch)
      freq = freq === 0 ? _channel.freq : freq
      const T = freq === 0 ? 0 : (1 / freq) // time unit is 'ms'
      this.board.create('functiongraph', [
        (t) => {
          return fourierSeries(t, T, _channel.amp, _channel.offset)
        }, boundingBox[0], boundingBox[2]],
      { strokeColor: color, strokeWidth: 1 }
      )
    },
    drawTriWave (ch, freq = 0) {
      const _channel = this.getChannelObject(ch)
      const boundingBox = this.board.getBoundingBox()
      const color = this.getGraphColorByChannel(ch)
      freq = freq === 0 ? _channel.freq : freq
      const T = freq === 0 ? 0 : (1 / freq)// time unit is 'ms'
      this.board.create('functiongraph', [
        (x) => {
          return triangle(x, T, _channel.amp, _channel.offset)
        }, boundingBox[0], boundingBox[2]],
      { strokeColor: color, strokeWidth: 1 }
      )
    },
    drawStaticGraph (val1 = 0, val2 = 0, interval = 0.01) {
      let x = interval
      this.inter = setInterval(() => {
        if (this.channels.ch1.xdata.length < (1 / interval)) {
          this.channels.ch1.xdata.push(x)
          this.channels.ch2.xdata.push(x)
        } else {
          this.channels.ch1.ydata.splice(0, 1)
          this.channels.ch2.ydata.splice(0, 1)
        }
        this.channels.ch1.ydata.push(val1)
        this.channels.ch2.ydata.push(val2)
        x += interval
        this.board.update()
      }, 10)
    },
    drawRealtimeGraph (mode, ydata1, ydata2, timeList = [], periodTime = 100) {
      const interval = periodTime * 0.001
      const limit = (mode === 'period') ? timeList.length : 100
      let x = interval // periodTime (ms)
      let idx = 0
      this.inter = setInterval(() => {
        if (this.channels.ch1.xdata.length < limit) {
          this.channels.ch1.xdata.push(x)
          this.channels.ch2.xdata.push(x)
        } else {
          this.channels.ch1.ydata.splice(0, 1)
          this.channels.ch2.ydata.splice(0, 1)
        }
        this.channels.ch1.ydata.push(ydata1[idx])
        this.channels.ch2.ydata.push(ydata2[idx])
        if (mode === 'period') idx = (idx + 1) % timeList.length
        x += interval
        this.board.update()
      }, 10)
    },
    zoom (a = 1.25) { // 0.75 (zoomIn), 1.25 (zoomOut)
      const _boundingBox = this.board.getBoundingBox()
      if (_boundingBox[2] * a < ZOOM_MIN || _boundingBox[2] * a > ZOOM_MAX) return
      this.attr.factor.x = this.attr.factor.y = a
      const nx = _boundingBox[0] * a
      const ny = _boundingBox[1] * a
      const boundingBox = [nx, ny, -nx, -ny]
      this.board.setBoundingBox(boundingBox)
      this.board.fullUpdate()
      return boundingBox
    },
    /* zoomOut (a = 1.25) {
      const factor = this.mode === 'single' ? this.mainChannel.factor : this.attr.factor
      const _boundingBox = this.board.getBoundingBox()
      if (_boundingBox[2] * factor.x * a > ZOOM_MAX) return
      factor.x *= a; factor.y *= a
      const nx = _boundingBox[0] * factor.x
      const ny = _boundingBox[1] * factor.y
      const boundingBox = [nx, ny, -nx, -ny]
      this.board.setBoundingBox(boundingBox)
      // this.board.zoomOut(a, a)
      this.board.fullUpdate()
      return boundingBox
    }, */
    movePositionVertical (a = 0.1, ch = 'both') { // 그래프 y축의 BoundingBox에 대해서
      const _channel = ch === 'both' ? this.mainChannel : this.getChannelObject(ch)
      _channel.offset.y += a
    },
    movePositionHorizontal (a = 0.1, ch = 'both') { // 그래프 x축의 BoundingBox에 대해서
      const _channel = ch === 'both' ? this.mainChannel : this.getChannelObject(ch)
      _channel.offset.x += a
    },
    scalePositionHorizontal (a, ch = 'both') { // 그래프 y축의 BoudingBox에 대해서
      const _boudingBox = this.board.getBoundingBox()
      if (_boudingBox[3] * a > ZOOM_MAX) return
      const boundingBox = [_boudingBox[0] * a, _boudingBox[1], _boudingBox[2] * a, _boudingBox[3]]
      this.board.setBoundingBox(boundingBox)
      this.board.fullUpdate()
    },
    scalePositionVertical (a, ch = 'both') { // 그래프 x축의 BoudingBox에 대해서
      const _boudingBox = this.board.getBoundingBox()
      if (_boudingBox[2] * a > ZOOM_MAX) return
      const boundingBox = [_boudingBox[0], _boudingBox[1] * a, _boudingBox[2], _boudingBox[3] * a]
      this.board.setBoundingBox(boundingBox)
      this.board.fullUpdate()
    }
  }
}
